import { createSelector } from '@reduxjs/toolkit';
export const projectReducer = (state) => state.project;
export const projectSelector = createSelector(projectReducer, (project) => project);
